import { NEXT_PUBLIC_FIREBASE_API_KEY } from "@/libs/constants/auth";
import { fetchUtil } from "@/libs/fetch";
import { AuthRefreshPayload } from "@/redux/slice/auth/types/AuthRefreshPayload";

export const fetchAuthTokenViaRefreshApi = async (authRefreshPayload: AuthRefreshPayload): Promise<any> => {
  const { grant_type, refresh_token } = authRefreshPayload;

  return await fetchUtil({
    url: `https://securetoken.googleapis.com/v1/token?key=${NEXT_PUBLIC_FIREBASE_API_KEY}`,
    method: "POST",
    body: { grant_type, refresh_token },
    ctype: "",
    useToken: true,
  });
};
